// src/components/modals/AddProjectModal.tsx
import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTrigger,
} from "../ui/dialog";
import { DatePicker } from "../DatePicker";
import { PlusIcon } from "lucide-react";
import { ClipboardDocumentListIcon } from "@heroicons/react/24/solid";
import { useCreateProject, useGetAllProjects } from "@/api/ProjetsApi";
import { Project } from "@/types/project";
import { format } from "date-fns";
import SmallLoader from "../SmallLoader";

const AddProjectModal: React.FC = () => {
  const [title, setTitle] = useState("");
  const [location, setLocation] = useState("");
  // const [subTitle, setSubTitle] = useState("");
  const [description, setDescription] = useState("");
  const [startDate, setStartDate] = useState<Date>();
  const [endDate, setEndDate] = useState<Date>();

  const { createProject, loading } = useCreateProject();
  const { getAllProjects } = useGetAllProjects();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const newProject: Project = {
      // id: Date.now().toString(),
      title,
      // subTitle,
      description,
      // createdAt: new Date().toISOString(),
      status: "in_progress",
      // isFavorited: false,
      // type: "",
      start_date: startDate ? format(startDate, "yyyy-MM-dd") : "no start date",
      deadline: endDate ? format(endDate, "yyyy-MM-dd") : "no start date",
      objectives: "",
      location: location,
      // reference_number: "",
    };

    if (await createProject(newProject)) {
      setTitle("");
      setDescription("");
      // setSubTitle("");
      setLocation("");
      setStartDate(undefined);
      setEndDate(undefined);
      setOpen(false);
      getAllProjects();
    }
  };

  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button className="flex items-center justify-between bg-rajapiNavyBlue text-white rounded-2xl px-2 py-2 mr-7">
          <div className="bg-white p-3 rounded-xl mr-3">
            <PlusIcon className="h-5 w-5 text-rajapiNavyBlue" />
          </div>
          <span className="mr-2">Créer un projet</span>
        </button>
      </DialogTrigger>
      <DialogContent className="w-full max-w-xl p-8">
        <DialogHeader>
          <div className="w-full flex">
            <div className="bg-white p-4 rounded-2xl w-fit">
              <ClipboardDocumentListIcon className="w-6 h-6 text-rajapiBlue" />
            </div>
            {loading && <SmallLoader modal={true} />}
          </div>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <h2 className="text-lg font-medium text-black">
            Créer un nouveau projet
          </h2>
          <h2 className="text-xs font-medium text-gray">
            Commencez à créer et à gérer votre projet en quelques clics
            seulement !
          </h2>
          <div className="border-white border-2 px-3 py-4 bg-inherit rounded-2xl">
            <label className="block text-sm font-medium text-blue-950">
              Nom du projet
            </label>
            <input
              type="text"
              className="w-full bg-inherit font-light	outline-none text-xs	"
              value={title}
              placeholder="Entrez votre nom de projet"
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </div>
          <div className="border-white border-2 px-3 py-4 bg-inherit rounded-2xl">
            <label className="block text-sm font-medium text-blue-950">
              Localisation du projet
            </label>
            <input
              type="text"
              className="w-full bg-inherit font-light	outline-none text-xs	"
              value={location}
              placeholder="Entrez votre soustitre de projet"
              onChange={(e) => setLocation(e.target.value)}
              required
            />
          </div>
          {/* <div className="border-white border-2 px-3 py-4 bg-inherit rounded-2xl">
            <label className="block text-sm font-medium text-blue-950">
              Soustitre du projet
            </label>
            <input
              type="text"
              className="w-full bg-inherit font-light	outline-none text-xs	"
              value={subTitle}
              placeholder="Entrez votre soustitre de projet"
              onChange={(e) => setSubTitle(e.target.value)}
              required
            />
          </div> */}
          <div className="border-white border-2 px-3 py-2 bg-inherit rounded-2xl">
            <label className="block text-sm font-medium text-blue-950">
              Description du projet
            </label>
            <textarea
              className="w-full bg-inherit font-light	outline-none text-xs	"
              value={description}
              placeholder="Entrez votre description de projet"
              onChange={(e) => setDescription(e.target.value)}
              required
            ></textarea>
          </div>
          <DatePicker
            label="Entrez la de début du projet"
            date={startDate}
            setDate={setStartDate}
          />
          <DatePicker
            label="Entrez la deadline du projet"
            date={endDate}
            setDate={setEndDate}
          />
          <div className="mt-4 flex justify-center">
            <button
              className="mr-2 bg-rajapiBlue py-4 px-20 rounded-xl text-white text-sm"
              type="submit"
              disabled={
                description.length === 0 ||
                title.length === 0 ||
                // subTitle.length === 0 ||
                location.length === 0 ||
                startDate === undefined ||
                endDate === undefined
              }
            >
              Continue
            </button>
            <button
              className="mr-2 bg-white py-4 px-20 rounded-xl text-blue-950 text-sm"
              onClick={() => setOpen(false)}
            >
              Annuler
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddProjectModal;
